/**
 * Start a browser download for an already-resolved URL.
 *
 * Opening the URL in a new tab needs transient user activation, which a browser
 * only grants for a few seconds after the click. Server-built bundles take
 * longer than that to come back, so the tab is treated as a blocked popup and
 * nothing happens. Navigating the current tab needs no activation, and the
 * presigned URLs carry Content-Disposition: attachment, so the page stays put.
 */
export function triggerBrowserDownload(url: string, filename: string): void {
  if (!url) return;

  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  link.rel = 'noopener';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
